export type ImpersonationEnvironment = 'tenant' | 'student';

export function resolveImpersonationEnvironment(user: {
  context?: string | null;
  roles?: string[] | null;
  role?: string | null;
}): ImpersonationEnvironment | null {
  const context = user.context?.trim().toLowerCase();

  if (context === 'admin') {
    return 'tenant';
  }

  if (context === 'app') {
    return 'student';
  }

  if (context === 'master') {
    return null;
  }

  const roles = user.roles ?? [];
  const hasAdmin = roles.some(role => role === 'admin:*' || role.startsWith('admin:'));
  const hasApp = roles.some(role => role === 'app:*' || role.startsWith('app:'));
  const hasMaster = roles.some(role => role === 'master:*' || role.startsWith('master:'));

  if (hasMaster && !hasAdmin && !hasApp) {
    return null;
  }

  if (hasAdmin && !hasApp) {
    return 'tenant';
  }

  if (hasApp && !hasAdmin) {
    return 'student';
  }

  if (user.role === 'admin') {
    return 'tenant';
  }

  if (user.role === 'user') {
    return 'student';
  }

  return null;
}
